import { IEnvVars } from "shared/utils";

const LOCAL_ENV_VARS: IEnvVars = {
  CLIENT_ID: "67154-ASDS-WebApp",
  API_ENDPOINT: "http://localhost:8086/apm",
  FEL_ENDPOINT: "https://qasds.honeywellaerospace.com/servicerequest/elt/swlib/servicehome.do",
  ASDS_ENDPOINT: "https://qads.honeywellaerospace.com/ads/broadcast/message",
};

export default LOCAL_ENV_VARS;
